/**
 * CSV による一括登録（課題 #94 / #51）の画面で使う定義と判定。
 */
import type { BulkImportPreviewResponse } from '../api/client';

/** CSV の見出し（BE の合意どおり。#51 9/8） */
export const BULK_IMPORT_COLUMNS = ['email', 'display_name', 'role', 'department_name'] as const;

/**
 * 見本の CSV。見出しの行だけにする。例の行を入れておくと、消し忘れたまま取り込んで
 * 例のアドレスに招待を送ってしまうため。Excel で文字化けしないよう BOM を付ける。
 */
export function bulkImportTemplateCsv(): string {
  return `\uFEFF${BULK_IMPORT_COLUMNS.join(',')}\r\n`;
}

/** 行の結果の表示名のキー。BE が知らない値を返したら null（生の値を出す） */
export function bulkRowResultKey(result: string): string | null {
  return ['ready', 'skipped', 'error', 'invited'].includes(result) ? result : null;
}

/**
 * 表記ゆれの恐れがある、新しく作られる部署。既存の部署に似ているもの（similar_existing）と、
 * CSV の中のほかの新しい部署に似ているもの（similar_new。課題 #94）の両方を数える
 */
export function similarNewDepartments(preview: Pick<BulkImportPreviewResponse, 'new_departments'>) {
  return preview.new_departments.filter(
    (d) => (d.similar_existing ?? []).length > 0 || (d.similar_new ?? []).length > 0
  );
}

/** 部署の一括更新の CSV の見出し（課題 #94。BE に提案中の形） */
export const BULK_DEPARTMENT_COLUMNS = ['email', 'department_name'] as const;

/** 部署の一括更新の見本の CSV。一括登録と同じく、見出しの行だけにし、BOM を付ける */
export function bulkDepartmentTemplateCsv(): string {
  return `\uFEFF${BULK_DEPARTMENT_COLUMNS.join(',')}\r\n`;
}

/** 部署の一括更新の行の結果の表示名のキー。BE が知らない値を返したら null（生の値を出す） */
export function bulkDepartmentResultKey(result: string): string | null {
  return ['change', 'unchanged', 'error', 'updated'].includes(result) ? result : null;
}

/** 古い BE（部署の一括更新の API が無い）か。ルートが無いときは、エラーコードの無い 404 */
export function isBulkDepartmentUnavailable(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false;
  const e = err as { status?: unknown; errorCode?: unknown };
  return (e.status === 404 || e.status === 405) && !e.errorCode;
}
